<template>
   <div class="Communication">
      <h6 class="title">
         <Icon icon="iconGroup" />Kommunikation 18 Monate
      </h6>
      <MessageEditor ref="MessageEditor"
         :customer="customer"
         @send="onCommentSend" />
      <div class="comments">
         <div v-for="comment in commentsSorted"
            :key="comment._id"
            class="comment"
            :class="{ pinned: comment.pinned }">
            <div class="col left">
               <div class="commentHeader">
                  <div class="left">
                     <div class="month">{{ getDate(comment.date) }}</div>
                     <div class="contactName">{{ comment.userName }} </div>
                  </div>
                  <div class="middle">
                     <div class="userName">{{ comment.contactName }}</div>
                  </div>
                  <div class="right">
                     <div v-if="comment.nextContactDate"
                        class="nextContact"
                        :class="{ red: !comment.nextContactDone }">{{ `nächster Kontakt
                        ${getDate(comment.nextContactDate)}` }}</div>
                  </div>
               </div>
               <Textarea class="text"
                  :readonly="true"
                  :value="comment.comment" />
            </div>
            <div class="col right hoverMenu">
               <div class="flyOutBtn">
                  <div class="btn">
                     <MenuMore orientation="right">
                        <div class="item"
                           @click="onCommentEdit(comment._id)">Bearbeiten</div>
                        <div class="item"
                           @click="onCommentDelete(comment._id)">Löschen</div>
                        <div v-if="!comment.pinned"
                           class="item"
                           @click="onCommentPin(comment._id, true)">Pinnen</div>
                        <div v-else
                           class="item"
                           @click="onCommentPin(comment._id, false)">Unpinnen</div>
                        <template v-if="comment.nextContactDate">
                           <div v-if="!comment.nextContactDone"
                              @click="onCommentDone(comment._id, true)">Erledigt setzen</div>
                           <div v-else
                              class="item"
                              @click="onCommentDone(comment._id, false)">Erledigt löschen</div>
                        </template>
                     </MenuMore>
                  </div>
               </div>
            </div>
            <!-- <div class="col right hoverMenu">
               <button class="flyOutBtn"
                  :popovertarget="`menu${comment._id}`"
                  popovertargetaction="toggle">
                  <div class="btn">
                     <Icon icon="iconEdit" />
                  </div>
               </button>
               <div :id="`menu${comment._id}`"
                  popover
                  class="flyOut">
                  <div class="btn"
                     @click.stop="onCommentDelete(comment._id)">
                     <Icon icon="iconDelete" />
                  </div>
               </div>
            </div> -->
         </div>
      </div>
   </div>
</template>

<script>
import portalStateP from '@components/Portal/portalState';
const portalState = portalStateP()


import CheckBox from '@components/Form/CheckBox.vue';
import Icon from "@icons/Icon.vue"
import { Comment, Send, Delete, Edit } from "@icons/appFabric/icons"
import utils from "@SyoLab/utils"
import api from '@components/Portal/api';
import { DateTime, Timestamp, Day } from '@SyoLab/date-time';
import Textarea from '@components/Form/Textarea.vue';
import DatePicker from '@components/Form/DatePicker.vue';
import Dropdown from '@components/Form/Dropdown.vue';
import MessageEditor from './MessageEditor.vue'
import MenuMore from "@components/Navigation/MenuMore.vue"

export default {
   name: 'Communication',
   components: { CheckBox, Icon, Textarea, DatePicker, Dropdown, MessageEditor, MenuMore },
   props: {
      customer: { required: true }
   },
   data() {
      return {
         commentEdit_id: null,
         comment: null,
         contactId: null,
         date: null,
         nextContactDate: null,
      }

   },
   static: {
      iconGroup: Comment,
      iconSend: Send,
      iconDelete: Delete,
      iconEdit: Edit
   },
   methods: {
      getType(type) {
         if (type == 'bch') return 'Bildung-Schweiz'
      },
      getDate(date) {
         if (!date) return null
         return new Day(date).toEuDate()
      },
      onCommentSend(comment) {
         let index = this.customer.customerCommunication.findIndex(c => c._id == comment._id)
         if (index > -1) {
            this.customer.customerCommunication[index] = comment
         } else {
            this.customer.customerCommunication.push(comment)
         }
         api.post('customer/customerCommunication', comment)
      },
      onCommentDelete(_id) {
         let index = this.customer.customerCommunication.findIndex(comment => comment._id == _id)
         this.customer.customerCommunication.splice(index, 1)
         api.delete(`customer/customerCommunication/${_id}`)

      },
      onCommentEdit(_id) {
         let comment = this.customer.customerCommunication.find(comment => comment._id == _id)
         if (comment) {
            this.$refs.MessageEditor.onCommentEdit(comment)
            this.onCommentDelete(_id)
         }
      },
      onCommentPin(_id, value) {
         let comment = this.customer.customerCommunication.find(comment => comment._id == _id)
         if (comment) {
            this.$set(comment, 'pinned', value)
            this.onCommentSend(comment)
         }
      },
      onCommentDone(_id, value) {
         let comment = this.customer.customerCommunication.find(comment => comment._id == _id)
         if (comment) {
            comment.nextContactDone = value
            if (value) {
               api.put(`customer/nextContact/${_id}/done`)
            } else {
               api.delete(`customer/nextContact/${_id}/done`)
            }
         }
      },
   },
   computed: {
      commentsSorted() {
         let d = new Day().minus({ months: 18 }).date
         let comments = [...this.customer.customerCommunication]
         comments = comments.filter(comment => {
            return comment.date > d
         })
         return comments.sort((a, b) => {
            if (a.pinned && !b.pinned) return -1
            if (!a.pinned && b.pinned) return 1
            if (a.date > b.date) return -1
            if (a.date < b.date) return 1
            return a.timeStamp > b.timeStamp ? -1 : 1
         })
      },
   },
   watch: {
      customer() {
         this.contactId = null
      }
   },
   created() {
      this.date = new Day().date
      this.contactId = null

   }
}
</script>

<style scoped>
.Communication {
   padding-top: 20px;
}

.title {
   display: flex;
   column-gap: 10px;
   margin-bottom: 15px;
}

.title .Icon {
   font-size: 18px;
}


.comments {
   display: flex;
   flex-direction: column;
   row-gap: 15px;
   /* overflow-y: auto;
   overflow-x: hidden; */
}

Textarea {
   padding: 3px 5px;
   flex-grow: 1;
}

.message {
   padding-bottom: 15px;
}

.message .info {
   font-size: 12px;
   color: #a5a2a2;
   padding-bottom: 5px;
   padding-left: 3px;

}

.MessageEditor {
   padding-bottom: 15px;

}


.textarea {
   display: flex;
   background-color: #f9f9f9fc;
   width: 100%;
   padding: 3px 0;
   border-radius: 3px;
}

.textarea.new {
   background-color: var(--activeHover);
   border-radius: 3px;

   .col {
      justify-content: center;
      align-items: center;
      padding: 0 5px;
      position: relative;

   }
}


.col {
   display: flex;
   flex-direction: column;

}

.col.left {
   flex-grow: 1;
}

.col.right {
   justify-content: center;
   align-items: center;
   padding: 0 5px;
   position: relative;
}


.comment {
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   background-color: #f9f9f9fc;

   &.pinned {
      background-color: #fbfbb4fc;
   }
}

.commentHeader {
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   align-items: center;
   font-size: 11px;
   padding-top: 3px;
   color: #a5a2a2;
}

.commentHeader>div {
   display: flex;
   align-items: center;
}

.commentHeader .middle {
   justify-content: center;
}

.commentHeader .right {
   justify-content: flex-end;
}

.commentHeader .contactName {
   padding-left: 6px;
}

.commentHeader .month {
   padding-left: 6px;
}

.commentHeader .userName {
   padding-right: 6px;
}

.comment .text {
   flex-grow: 1;
   padding-bottom: 6px;
}

.comment .Icon {
   font-size: 14px;
}



.btn {
   padding: 5px;
   border-radius: 3px;
}

.btn.active {
   background-color: #c7e0f3;
}

.comment .btn:hover {
   background-color: var(--activeHover);
}

.filterRow {
   display: flex;
   align-items: flex-start;
   height: 32px;
   gap: 15px;
}

.hoverMenu {
   position: relative;
}

.flyOutBtn {
   anchor-name: --anchor-el;
}

.flyOut {
   position: absolute;
   background-color: #f9f9f9fc;
   border-radius: 3px;
   padding: 5px;
   z-index: 3;
   position-anchor: --anchor-el;
   top: anchor(--anchor-el bottom);
   margin: 0;
}

.nextContact.red {
   color: red;
}

/* .hoverMenu:hover .flyOut {
   display: block;

} */
</style>